import React from "react";
import Plot from "react-plotly.js";

const ScatterPlot = ({ data, xKey, yKey, colorKey, zKey }) => {
  if(data[yKey] == undefined ||data[yKey] == null){
    return(<>
      </>);
  }
  if((zKey && zKey.length > 0)){
    return(<>
    </>);
  }
  if(xKey == null || xKey == undefined || xKey.length == 0){
    return(<>

      </>);
  }
  if(yKey == null || yKey == undefined || yKey.length == 0){
    return(<>
    
      </>);
  }
  const plotData = {
    x: data[xKey],
    y: data[yKey],
    mode: "markers",
    marker: {
      size: 12,
    },
  };

  if (colorKey && data[colorKey]) {
    plotData.marker.color = data[colorKey];
    plotData.marker.colorscale = "Viridis";
    plotData.marker.showscale = true;
  }

  return (
    <Plot
      data={[plotData]}
      layout={{
        title: "Scatter Plot with Color Scale",
        xaxis: { title: xKey },
        yaxis: { title: yKey },
      }}
      style={{ width: "100%", height: "100%" }}
    />
  );
};

export default ScatterPlot;
